import { Box, Flex, Image, Text } from '@chakra-ui/react';
import React from 'react';
import textColorForBackground from '../../utils/textColorForBackground';
import Tooltips from './Tooltips';
import AvisoSemColecao from './vitrines/AvisoSemColecao';
import {
  ARREDONDAMENTO,
  COR_DE_FUNDO_PADRAO,
  ESPACAMENTO,
} from './vitrines/constantes';
import SilhuetaProduto from './vitrines/SilhuetaProduto';

interface Props {
  data: any;
  phoneWidth?: number;
}

const LARGURA_BANNER = 150;

const VitrineComBanner: React.FC<Props> = ({ data }) => {
  const banner = (data?.items ?? [])[0];
  const fundo = data?.background_color || COR_DE_FUNDO_PADRAO;
  // a cor do fundo e livre, entao o texto acompanha para nao sumir
  const corDoTexto = textColorForBackground(fundo);

  return (
    <Box
      w="100%"
      position="relative"
      backgroundColor={fundo}
      borderRadius="6px"
      transition="150ms ease"
      py={`${ESPACAMENTO}px`}
    >
      <Flex
        align="center"
        justify="space-between"
        px={`${ESPACAMENTO}px`}
        mb={3}
      >
        <Flex align="center" gap={2}>
          <Text fontWeight="bold" fontSize="md" color={corDoTexto}>
            {data?.name || 'Vitrine'}
          </Text>
          <Tooltips data={data} />
        </Flex>
        {data?.action_text ? (
          <Text fontSize="xs" color={corDoTexto}>
            {data.action_text} ›
          </Text>
        ) : null}
      </Flex>

      {/* stretch: o banner acompanha a altura do card, como no app */}
      <Flex
        gap={`${ESPACAMENTO}px`}
        px={`${ESPACAMENTO}px`}
        overflowX="hidden"
        align="stretch"
      >
        {banner?.file?.url ? (
          <Image
            flexShrink={0}
            w={`${LARGURA_BANNER}px`}
            objectFit="cover"
            borderRadius={`${ARREDONDAMENTO}px`}
            src={banner.file.url}
            alt={banner?.image_description || banner?.name || ''}
          />
        ) : (
          <Flex
            flexShrink={0}
            w={`${LARGURA_BANNER}px`}
            align="center"
            justify="center"
            borderWidth="3px"
            borderStyle="dashed"
            borderRadius="6px"
          >
            <Text color="gray.500" fontSize="xs" textAlign="center">
              + Banner
            </Text>
          </Flex>
        )}

        <SilhuetaProduto />
        <SilhuetaProduto />
      </Flex>

      {!data?.reference_id ? <AvisoSemColecao /> : null}
    </Box>
  );
};

export default VitrineComBanner;
